import { Component, OnInit } from '@angular/core';
import { AuthService } from '../user/services/auth.service';
import { UserService } from '../user/services/user.service';
import { Router } from '@angular/router';
import { UserSessionComponent } from 'src/app/dashboard/user-session/user-session.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss']
})
export class SsoComponent implements OnInit {
  errorMessage = '';
  ssValues: any;
  current = 0;

  constructor(
    private authService:AuthService,
    private router:Router,
    private userService:UserService,
    private userSessionDialog : MatDialog
    ) {}

  ngOnInit(): void {
    if(this.authService.isLoggedIn){
      this.router.navigate(['/dashboard']);
    } else {
      const sso_jwt = this.router.url.split("/sso/")[1];
      console.log("no log in");
      //console.log(sso_jwt);
      if(sso_jwt != undefined){
        this.userService.sso(sso_jwt).subscribe(
          (res:any) => {
            if(res.responseStatus === 'Success'){
              this.errorMessage = '';
              this.current = this.current + 1;
              this.authService.login(res.responseData.userId,res.responseToken.token, res.responseToken.maxSession, res.responseToken.sessionValsLength)
              this.ssValues = res.responseToken;
              //if user session exists then show up the session management dialog
              if(res.responseToken.sessionVals.result.length > 0) {
                this.userSessionDialog.open(UserSessionComponent, {
                  width: '50rem',
                  height: '30rem',
                  data: this.ssValues,
                  disableClose :false,
                });
              } else {
                this.router.navigate(['/dashboard']);
              }   
              }
            else {
              this.errorMessage = res.responseMessage;
              this.authService.logout();
              this.router.navigate(['/user/login']);
            }
          },
          err => {
            this.errorMessage = JSON.stringify(err);
            console.log('Login Failed',err);
          }
        )       
      }
    }   
  }
}
